import { useMemo as s } from "react";
import { A } from "../../../index.modern-BBWGIH4W.js";
import "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as a } from "../../../context/theme/hooks.js";
import { HOVER_OVERLAY_OPACITY as l, ACTIVE_OVERLAY_OPACITY as i } from "../consts.js";
import { baseColorHexToRGBA as C, overlayColorHexToRGBA as R, RGBAToString as p } from "../utils.js";
function d(o, r) {
  const e = a();
  return s(() => {
    const t = C(o), m = R(
      e["hover-and-active-overlay"],
      r === "hover" ? l : i
    ), n = A(t, m);
    return p(n);
  }, [o, r, e]);
}
export {
  d as default
};
